import {useCallback} from "react";
import {ACES, Roles} from "../components/admin/user/UserManager.types";
import {updateAces} from "../commons/updateAces";

const useHandleSingleUserAcesModification = (
  updateUserAces: ({userId, aces}: { userId: any, aces: Pick<ACES, "target" | "roles">[] }) => Promise<void>,
) => {
  return useCallback(async (userId: number, aces: Pick<ACES, "target" | "roles">[], newFormData: { [p: string]: Roles[] | undefined }) => {
    await updateAces(
      aces,
      newFormData,
      userId,
      updateUserAces,
    )
  }, [updateUserAces])
}

export default useHandleSingleUserAcesModification